import { AnyAction, Dispatch } from 'redux';

import { OauthApiService } from '@ClientApi/oauth';
import { IOauthAccessTokenModel } from '@Shared/models';

export const OAUTH_TOKENS_SET_LOADING = 'OAUTH_TOKENS_SET_LOADING';
export const OAUTH_TOKENS_SET_TOKENS = 'OAUTH_TOKENS_SET_TOKENS';

export class SetLoading {
  readonly type = OAUTH_TOKENS_SET_LOADING;
  payload: boolean;
  constructor(loading: boolean) {
    this.payload = loading;
  }
}

export class SetTokens {
  readonly type = OAUTH_TOKENS_SET_TOKENS;
  payload: IOauthAccessTokenModel[];
  constructor(public tokens: IOauthAccessTokenModel[]) {
    this.payload = tokens;
  }
}

export const init = (dispatch: Dispatch<AnyAction>) => async () => {
  dispatch(new SetLoading(true));
  const tokens = await OauthApiService.getUserTokens();
  dispatch(new SetTokens(tokens));
};

export const revoke = (dispatch: Dispatch<AnyAction>) => async (id: string) => {
  dispatch(new SetLoading(true));
  const tokens = await OauthApiService.revoke(id);
  dispatch(new SetTokens(tokens));
};

export type OauthTokensPageAction = SetLoading | SetTokens;
